import { SQLService } from '../../../services/sql.service';
import { ModalController } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'ng-cheques-administratior-menu',
  templateUrl: './new-qr-administrator.component.html',
  styleUrls: ['./new-qr-administrator.component.styl']
})
export class NewQRAdministratiorComponent implements OnInit {
  constructor(
    public sql: SQLService,
    private navCtrl: ModalController,
    private router: Router) {
  }
  list:string;
  end(e) {
    if (this.navCtrl) this.navCtrl.dismiss(e);
  }
  ngOnInit() {
  }
}